module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('menu-bar', [_c('router-link', {
    attrs: {
      "slot": "title",
      "to": "/"
    },
    slot: "title"
  }, [_c('h1', [_vm._v("Bendpanic")]), _vm._v(" "), _c('h2', {
    staticClass: "subheader"
  }, [_vm._v("Production")])]), _vm._v(" "), _c('categories', {
    attrs: {
      "slot": "categories",
      "categories": _vm.categories
    },
    slot: "categories"
  })], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('foot')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 119
// module chunks = 0